import TopLevelMethod from "./TopLevelMethod";
import ViewerEvent from "./ViewerEvent";
import ViewerMethod from "./ViewerMethod";
import { ApiActionRequest } from "./action-types";

export enum ActionTarget {
  VIEWER = "viewer",
  WINDOW = "window",
}

export const ACTION_TYPE = "mosaic-middleware-action";

export function createTopLevelAction(apiMethodName: TopLevelMethod) {
  return function (...apiCallArgs): ApiActionRequest {
    return {
      type: ACTION_TYPE,
      mosaic: {
        apiMethodName,
        apiCallArgs,
        apiTarget: ActionTarget.WINDOW,
      },
    };
  };
}

export function createViewerAction(apiMethodName: ViewerMethod) {
  return function (...apiCallArgs): ApiActionRequest {
    return {
      type: ACTION_TYPE,
      mosaic: {
        apiMethodName,
        apiCallArgs,
        apiTarget: ActionTarget.VIEWER,
      },
    };
  };
}

export function createEventAction(eventName: ViewerEvent) {
  return function (eventData) {
    return {
      type: getEventActionName(eventName),
      eventData,
      timestamp: new Date().valueOf(),
    };
  };
}

export function getStartActionName(method: string) {
  return `mosaic/${method}/start`;
}

export function getSuccessActionName(method: string) {
  return `mosaic/${method}/success`;
}

export function getFailActionName(method: string) {
  return `mosaic/${method}/fail`;
}

export function getEventActionName(event: string) {
  return `mosaic/${event}`;
}
